export const CLIENT_BASE_URL = process.env.CLIENT_URL || 'http://localhost:3000';
export const TG_FIELD_DEFAULT_VALUE = 'https://t.me/';
